/* 
 * Export component file to be used on project
*/

import Dropdown from './Dropdown.js';
export default Dropdown;
